import { render, staticRenderFns } from "./integralTicket.vue?vue&type=template&id=499b7c5a&scoped=true&"
import script from "./integralTicket.vue?vue&type=script&lang=js&"
export * from "./integralTicket.vue?vue&type=script&lang=js&"
import style0 from "./integralTicket.vue?vue&type=style&index=0&id=499b7c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b7c5a",
  null
  
)

export default component.exports